import { Avatar, Button, List, Skeleton, Typography } from "antd";
import React from "react";
import Link from "antd/es/typography/Link";
import JobApplyForm from "./JobApplyForm";
import { JobInterface } from "api/jobs/dto";
import ErrorPage from "components/ui/ErrorPage";
import { useGetMyJobs } from "api/jobs/useGetMyJobs";
import { storage } from "utils/storage";


const { Title, Text } = Typography;
const joblocationFormat = (item: JobInterface) => {
  const locations = item.joblocation || [];

  if (locations.length === 0) {
    return "Location not specified";
  } else if (locations.length > 2) {
    const displayedLocations = locations
      .slice(0, 2)
      .map(loc => `${loc.district} ${loc.province}`)
      .join(", ");
    const remaining = locations.length - 2;
    return `${displayedLocations} and ${remaining} more`;
  } else {
    return locations.map(loc => `${loc.district} ${loc.province}`).join(", ");
  }
};


const SavedJobs: React.FC = React.memo(() => {
  const user = storage.getUserFromStorage();

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [jobData, setJobData] = React.useState<JobInterface | null>(null);

  const { data, isFetching, error } = useGetMyJobs({
    isApplied: false,
    isSaved: true,
    userId: user?.uid,
  });

  if (error) {
    return <ErrorPage error={error} />;
  }
  return (
    <>
      <Title level={2} style={{ marginBottom: "16px" }}>
        Saved Jobs
      </Title>
      <List
        loading={isFetching}
        itemLayout="horizontal"
        dataSource={data}
        locale={{
          emptyText: isFetching
            ? "Loading saved jobs..."
            : "You have no saved jobs.",
        }}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                className="h-10 px-4 text-base bg-primary text-white"
                type="primary"
                onClick={() => {
                  setJobData(item);
                  setIsModalOpen(true);
                }}
              >
                Apply Now
              </Button>,
            ]}
          >
            <Skeleton avatar title={false} loading={isFetching} active>
              <List.Item.Meta
                avatar={
                  <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" />
                }
                title={<Title level={4}>
                  <Link href={`/enumerator/job/details/${item?.id}`} className="text-lg" >
                    {item?.jobTitle}
                  </Link>
                </Title>}
                description={
                  <>
                    <Text strong>{item?.companyName}</Text>
                    <br />
                    <Text type="secondary">{joblocationFormat(item)}</Text>
                  </>
                }
              />
            </Skeleton>
          </List.Item>
        )}
      />

      {jobData && (
        <JobApplyForm
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          id={jobData.id}
          isSaveJobs={false}
          enumeratorId={user?.uid}
        />
      )}
    </>
  );
});

export default SavedJobs;
